import { create } from "zustand";
import { catalogProductOptionalField, CommonResponseModel, EcomProduct, whatsAppCatalog } from "../models/axiosModel";
import agent from "../services/api";

interface productStoreInterface {
    flagCreateProductPopup: boolean, 
    setFlagCreateProductPopup: (value: boolean) => void,

    eComProductData: EcomProduct[] | null,
    setEComProductData: (value: EcomProduct[]) => void, 

    filteredEComProductData: EcomProduct[] | null,
    setFilteredEComProductData: (value: EcomProduct[]) => void, 
    
    getEComProductApi: (organization_id: string) => Promise<CommonResponseModel<EcomProduct | null>>,

    catalogProductOptionalFieldData: catalogProductOptionalField[] | null,
    setCatalogProductOptionalFieldData: (value: catalogProductOptionalField[] | null) => void, 

    getCatalogProductOptionalFieldApi: () => Promise<CommonResponseModel<catalogProductOptionalField>>,

    whatsAppCatalogsData: whatsAppCatalog[] | null,
    setWhatsAppCatalogsData: (value: whatsAppCatalog[] | null) => void,

    getWhatsAppCatalogsDataApi: () => Promise<CommonResponseModel<whatsAppCatalog>>
}

export const useProductStore = create<productStoreInterface>((set) => ({
    flagCreateProductPopup: false,
    setFlagCreateProductPopup: (value: boolean) => set({ flagCreateProductPopup: value }),   

    eComProductData: null,
    setEComProductData: (value) => set({ eComProductData: value }), 

    filteredEComProductData: null,
    setFilteredEComProductData: (value) => set({ filteredEComProductData: value }), 

    getEComProductApi: async (organization_id: string) => {
        const res = await agent.getEComProduct.get(organization_id);
        if (res.status) {
            set({ eComProductData: res?.data })
        }
        else {
            set({ eComProductData: null })
        }
        return res;
    },

    catalogProductOptionalFieldData: null,
    setCatalogProductOptionalFieldData: (value: catalogProductOptionalField[] | null) => set({ catalogProductOptionalFieldData: value }),

    getCatalogProductOptionalFieldApi: async () => {
        const res = await agent.getCatalogProductOptionalFields.get();
        if(res?.status){
            set({ catalogProductOptionalFieldData: res?.data })
        } else {
            set({ catalogProductOptionalFieldData: null });
        }
        return res;
    }, 

    whatsAppCatalogsData: null,
    setWhatsAppCatalogsData: (value: whatsAppCatalog[] | null) => set({ whatsAppCatalogsData: value }),


    getWhatsAppCatalogsDataApi: async () => {
        const res = await agent.getWhatsAppCatalogs.get();
        if(res?.status){
            set({ whatsAppCatalogsData: res?.data });
        } else {
            set({ whatsAppCatalogsData: null });
        }
        return res;
    } 

    
}))